const translation = {
  tags: {
    design: 'Oblikovanje',
    videos: 'Videi',
    education: 'Izobraževanje',
    search: 'Iskanje',
    image: 'Slika',
    medical: 'Medicinski',
    weather: 'Vreme',
    social: 'Družbeni',
    entertainment: 'Zabava',
    productivity: 'Produktivnost',
    finance: 'Finance',
    news: 'Novice',
    business: 'Poslovanje',
    utilities: 'Komunalne storitve',
    agent: 'Agent',
    other: 'Drugo',
    travel: 'Potovanje',
  },
  searchTags: 'Iskalne oznake',
  allTags: 'Vse nalepke',
}

export default translation
